export class LocalStorageKeys {
  static brand_access_token = "brand_access_token";
  static brand_temporary_access_token = "brand_temporary_access_token";
  static user_data = "user_data";
  static agency_data = "agency_data";
  static agent_data = "agent_data";
  static registration_data = "registration_data";
  static session_user_type = "session_user_type";
  // static mylo_user_access_token = "mylo_user_access_token";
  // static mylo_user_question_id ="mylo_user_question_id"
}

export class QuestionStatus {
  static DRAFT = "draft";
  static FINALIZED = "finalized";
  static PENDING = "pending";
  static INCOMING = "incoming";
  static ACCEPTED = "accepted";
  static ACTIVE = "active";
  static REJECTED = "rejected";
  static UNANSWERED = "unanswered";
  static INAPPROPRIATE = "INAPPROPRIATE";
  static CANCELLED = "cancelled";
}

export class CommonUtils {
  /**
   * Reads a File object (from an input) and returns its content as a promise resolving to an ArrayBuffer.
   * This is the standard way to get raw binary data from a file on the client-side.
   * @param {File} file - The image file object from the input event.
   * @returns {Promise<ArrayBuffer>} The file data as an ArrayBuffer.
   */
  static fileToArrayBuffer = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const arrayBuffer = event.target.result;

        // Create a NEW Blob from the ArrayBuffer, preserving the original MIME type
        const newBlob = new Blob([arrayBuffer], { type: file.type });

        resolve(newBlob);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      // Read the file's binary content
      reader.readAsArrayBuffer(file);
    });

    // return new Promise((resolve, reject) => {
    //   const reader = new FileReader();

    //   // Event fires when the read operation is successfully completed
    //   reader.onload = (event: any) => {
    //     // event.target.result contains the file data as an ArrayBuffer
    //     resolve(event.target.result);
    //   };

    //   // Event fires if the read operation fails
    //   reader.onerror = (error) => {
    //     reject(error);
    //   };

    //   // Read the file's binary content
    //   reader.readAsArrayBuffer(file);
    // });
  };

  /**
   * Get fullname for the agent using agent data
   * @param {PrincipalAgent} agentData
   * @returns
   */
  static getAgentName = (agentData: any) => {
    let userData: any = agentData;

    let agentName = "";

    agentName = `${userData?.principal_agent_first_name} ${userData?.principal_agent_last_name}`;

    return agentName;
  };

  /**
   * Create clone for the object or array
   *
   * Plain js function Mimicking the cloneDeep() function from lodash library
   *
   * @param {Array | Object} value
   * @param seen
   * @returns
   */
  static cloneDeep = (
    value: [any] | Record<any, any>,
    seen = new WeakMap(),
  ) => {
    if (value === null || typeof value !== "object") {
      return value;
    }

    if (seen.has(value)) {
      return seen.get(value);
    }

    if (Array.isArray(value)) {
      const clonedArray: any = [];

      seen.set(value, clonedArray);

      for (const item of value) {
        clonedArray.push(this.cloneDeep(item, seen));
      }

      return clonedArray;
    }

    const clonedObject: any = {};

    seen.set(value, clonedObject);

    for (const key of Object.keys(value)) {
      clonedObject[key] = this.cloneDeep(value[key], seen);
    }

    return clonedObject;
  };

  static formatPhoneNumber = (params: { phoneNumber: string }) => {
    let { phoneNumber } = params;
    // Check if the input is a valid string. If not, return an empty string.
    if (typeof phoneNumber !== "string") {
      return "";
    }

    // Remove any non-digit characters from the string.
    const cleaned = phoneNumber.replace(/\D/g, "");

    // If the number is 9 digits, add a leading '0'.
    // This handles the format where the '0' prefix is missing.
    let formattedNumber = cleaned;
    if (cleaned.length === 9) {
      formattedNumber = "0" + cleaned;
    }

    // Ensure the number is exactly 10 digits before formatting.
    // This is a basic validation to prevent formatting incorrect lengths.
    if (formattedNumber.length === 10) {
      const part1 = formattedNumber.substring(0, 4);
      const part2 = formattedNumber.substring(4, 7);
      const part3 = formattedNumber.substring(7, 10);

      // Join the parts with spaces to create the desired format.
      return `${part1} ${part2} ${part3}`;
    }

    // Return the original string if it doesn't match the expected lengths.
    return phoneNumber;
  };

  static formatWebsiteLinkForPreview = ({ website }: { website: string }) => {
    if (!website || typeof website !== "string") {
      return "";
    }

    let value = website.trim();

    // Handle Markdown links:
    // [https://wolffox.in](https://wolffox.in)
    const markdownMatch = value.match(/^\[([^\]]+)\]\(([^)]+)\)$/);

    if (markdownMatch) {
      value = markdownMatch[2];
    }

    // Remove accidental backslashes
    value = value.replace(/\\/g, "");

    // Remove leading/trailing whitespace
    value = value.trim();

    // Add protocol so URL() can parse domains like:
    // wolffox.in
    // www.wolffox.in
    if (!/^https?:\/\//i.test(value)) {
      value = `https://${value}`;
    }

    try {
      const url = new URL(value);

      return url.hostname.replace(/^www\./i, "");
    } catch {
      // Fallback for malformed input
      return value
        .replace(/^https?:\/\//i, "")
        .replace(/^www\./i, "")
        .replace(/\/+$/, "");
    }
  };
}
